import React from 'react';
import './summary.scss';
import sanitizeHtml from 'sanitize-html';
import PropTypes from 'prop-types';
import { SUCCES_SUMMARY_CODE } from '../../../constants/constants';
import { PaymentSummaryError } from './paymentSummaryError';
import { PaymentSummarySuccess } from './paymentSummarySuccess';

export const PaymentSummary = ({ paymentResponse, onMakeAnotherPayment, onUpdateBankDetails }) => {
  const { SummaryCode, ResponseMessage, ReceiptNumber, TransactionTime, TotalAmount } = paymentResponse;
  const sanitizedResponseMessage = sanitizeHtml(ResponseMessage, {
    allowedTags: ['br']
  });
  return (
    <div>
      {SummaryCode !== SUCCES_SUMMARY_CODE ? (
        <PaymentSummaryError
          onMakeAnotherPayment={onMakeAnotherPayment}
          sanitizedResponseMessage={sanitizedResponseMessage}
        />
      ) : (
        <PaymentSummarySuccess
          totalAmountPaid={TotalAmount}
          transactionTime={TransactionTime}
          receiptNumber={ReceiptNumber}
          onMakeAnotherPayment={onMakeAnotherPayment}
          onUpdateBankDetails={onUpdateBankDetails}
        />
      )}
    </div>
  );
};

PaymentSummary.propTypes = {
  paymentResponse: PropTypes.objectOf({
    SummaryCode: PropTypes.string,
    ResponseMessage: PropTypes.string,
    ReceiptNumber: PropTypes.string,
    TotalAmount: PropTypes.number,
    TransactionTime: PropTypes.string
  }),
  onMakeAnotherPayment: PropTypes.func,
  onUpdateBankDetails: PropTypes.func
};
